import { Subject } from 'rxjs';

export function downloadFile(url: string, options: DownloadFileOptions = {}) {
  const link = document.createElement('a');

  link.href = url;
  if ('inNewTab' in options) {
    link.target = '_blank';
  }
  if ('suggestedFileName' in options) {
    link.download = options.suggestedFileName;
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

interface DownloadFileOptions {
  inNewTab?: boolean;
  suggestedFileName?: string;
}

export function dataURLtoFile(dataurl: string, filename: string) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export function loadImage(url: string) {
  const image$ = new Subject<HTMLImageElement>();

  const image = new Image();

  image.onload = () => {
    image$.next(image);
  };

  image.onerror = error => {
    image$.error(error);
  };

  image.src = url;

  return image$.asObservable();
}

export function writeImageToClipboard(dataUrl: string) {
  navigator.clipboard.write([
    new ClipboardItem({
      'image/png': fetch(dataUrl).then(res => res.blob())
    })
  ]);
}

export function isImageClipboardSupported() {
  return 'write' in navigator.clipboard && 'ClipboardItem' in window;
}
